export type Period = "AM" | "PM"

const isValid12Hour = (value: string) => /^(0[1-9]|1[0-2])$/.test(value)
const isValidMinute = (value: string) => /^[0-5][0-9]$/.test(value)

type GetValidNumberConfig = { max: number; min?: number }

const getValidNumber = (value: string, { max, min = 0 }: GetValidNumberConfig) => {
  const numericValue = parseInt(value, 10)
  if (isNaN(numericValue)) {
    return "00"
  }
  const clamped = Math.min(max, Math.max(min, numericValue))
  return clamped.toString().padStart(2, "0")
}

export const getValid12Hour = (value: string) => {
  if (isValid12Hour(value)) {
    return value
  }
  return getValidNumber(value, { min: 1, max: 12 })
}

export const getValidMinute = (value: string) => {
  if (isValidMinute(value)) {
    return value
  }
  return getValidNumber(value, { max: 59 })
}

export const convert12HourTo24Hour = (hour: number, period: Period) => {
  if (period === "PM") {
    if (hour <= 11) {
      return hour + 12
    }
    return hour
  }
  if (hour === 12) {
    return 0
  }
  return hour
}

export const display12HourValue = (hours: number) => {
  const h12 = hours % 12 || 12
  return String(h12).padStart(2, "0")
}

export const nextHourDigits = (
  display: string,
  key: string,
  isContinuation: boolean,
  prevKey: string
) => {
  if (isContinuation && display.slice(1, 2) === "1" && prevKey === "0") {
    return "0" + key
  }
  return isContinuation ? display.slice(1, 2) + key : "0" + key
}

export const nextMinuteDigits = (display: string, key: string, isContinuation: boolean) => {
  return isContinuation ? display.slice(1, 2) + key : "0" + key
}

export const resolveHourFromDigits = (digits: string, period: Period) => {
  const numeric = parseInt(digits, 10)
  if (numeric >= 13 && numeric <= 23) {
    return numeric
  }
  const hours12 = parseInt(getValid12Hour(digits), 10)
  return convert12HourTo24Hour(hours12, period)
}

export const snapMinute = (current: number, step: number, direction: 1 | -1) => {
  const next =
    direction > 0
      ? Math.floor(current / step) * step + step
      : Math.ceil(current / step) * step - step
  return ((next % 60) + 60) % 60
}
